import doctorTheme, { transmissionTheme } from '../../theme/doctorTheme'

import { THEME_SWITCH } from '../actions/types'

const availableThemes = {
    default: {
        theme: doctorTheme,
        name: 'default',
    },
    transmission: {
        theme: transmissionTheme,
        name: 'transmission',
    },
}

interface ThemeStore {
    theme: {
        theme: any
        name: string
    }
}

const INITIAL_STATE: ThemeStore = {
    theme: availableThemes.default,
}

export default (state = INITIAL_STATE, action: any): ThemeStore => {
    switch (action.type) {
        case THEME_SWITCH:
            return {
                ...state,
                theme: availableThemes[action.payload.theme]
                    ? availableThemes[action.payload.theme]
                    : availableThemes.default,
            }

        default:
            return state
    }
}
